import moment from 'moment-timezone';
import React from 'react';

import ExpertPicture from '@/components/ExpertPicture';

import type { Expert } from '../../types';
import { useStyles } from './ExpertHeader.styles';

interface ExpertHeaderProps {
  expert: Expert;
  showConfirmationMessage?: boolean;
}

/**
 * Expert header component shown at the top of the signup modal.
 * Displays expert photo, name, timezone, and a CTA message.
 */
export function ExpertHeader({
  expert,
  showConfirmationMessage = false,
}: ExpertHeaderProps): JSX.Element {
  const s = useStyles();

  // Format location display from timezone
  const locationDisplay = expert.timezone
    ? `(GMT${moment.tz(expert.timezone).format('Z')}) ${expert.timezone
        .substring(expert.timezone.lastIndexOf('/') + 1)
        .replace(/_/g, ' ')}`
    : '';

  const firstName = expert.name.split(' ')[0];

  return (
    <div className={s.content}>
      <div className={s.header}>
        <ExpertPicture
          user={{
            picture_url: expert.pictureUrl,
            name: expert.name,
          }}
          size={48}
          link={false}
        />
        <div className={s.expertInfo}>
          <h3 className={s.expertName}>{expert.name}</h3>
          {locationDisplay && <p className={s.expertLocation}>Request call {locationDisplay}</p>}
        </div>
      </div>
      <p className={s.signupCta}>
        {showConfirmationMessage
          ? `Your consultation request has been sent to ${firstName}.`
          : `If ${firstName} accepts, your call will be instantly confirmed.`}
      </p>
    </div>
  );
}

export default ExpertHeader;
